import { List, ListItem, Button, CircularProgress, Box, Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import StockCardPackagingItem from 'components/stockCardItems/StockCardPackagingItem'
import { IStockCard } from 'interfaces/IStockCard'
import { IPackagingParts } from 'interfaces/IPackaging'

interface Props {
  stockCardData: IStockCard
  inOutDirection: string
  packagingParts: IPackagingParts[]
  onChange: (packagingPartId: string, value: any, key: string) => void
  onConfirm: () => void
  isLoading: boolean
  getValidationMessage: (stockCard: IStockCard) => string | null
  isSuperuser?: boolean
  onUpdate?: () => void
  isUpdating?: boolean
  onDelete?: () => void
  isEditing: boolean
  setIsEditing: (isEditing: boolean) => void
  onAddPackaging?: () => void
  onRemovePackaging?: (index: number) => void
  onPrefill?: () => void
}

export default function PackagingDialog(props: Props) {
  const {
    stockCardData,
    inOutDirection,
    packagingParts,
    onChange,
    onConfirm,
    isLoading,
    getValidationMessage,
    isSuperuser,
    onUpdate,
    isUpdating,
    onDelete,
    onAddPackaging,
    onRemovePackaging,
    onPrefill,
    isEditing,
    setIsEditing,
  } = props

  const canEdit = isSuperuser
  const validationMessage = getValidationMessage(stockCardData)

  return (
    <List>
      {canEdit && (
        <ListItem>
          <Box width="100%" display="flex" justifyContent="flex-end" gap={8}>
            {onPrefill && (isEditing || !stockCardData.isConfirmed) && (
              <Button
                variant="contained"
                color="secondary"
                onClick={onPrefill}
                disabled={isLoading}
              >
                Isi Semua Sesuai Jumlah Diminta
              </Button>
            )}
            <Button
              variant="outlined"
              color={isEditing ? 'secondary' : 'primary'}
              onClick={() => setIsEditing(!isEditing)}
            >
              {isEditing ? 'Cancel Edit' : 'Edit'}
            </Button>
          </Box>
        </ListItem>
      )}
      {stockCardData.stockCardPackaging.map((packaging, index) => (
        <ListItem key={packaging.packagingPartId} divider={index !== stockCardData.stockCardPackaging.length - 1}>
          <StockCardPackagingItem
            packaging={packaging}
            inOutDirection={inOutDirection}
            packagingParts={packagingParts}
            outgoingDestination={stockCardData.outgoingDestination}
            onChange={onChange}
            disabled={!!stockCardData.isConfirmed && !isEditing}
            isSuperuser={isSuperuser}
            isConfirmed={!!stockCardData.isConfirmed}
            isEditing={isEditing}
            onRemove={isEditing && onRemovePackaging ? () => onRemovePackaging(index) : undefined}
          />
        </ListItem>
      ))}
      {isEditing && onAddPackaging && (
        <ListItem>
          <Button variant="outlined" color="primary" onClick={onAddPackaging}>
            Add Packaging
          </Button>
        </ListItem>
      )}
      <ListItem>
        <Box display="flex" gap={8}>
          {isEditing ? (
            <>
              {onUpdate && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onUpdate}
                  disabled={isUpdating}
                  startIcon={
                    isUpdating ? <CircularProgress size={18} color="inherit" /> : null
                  }
                >
                  Update Stock Card
                </Button>
              )}
              {canEdit && onDelete && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={onDelete}
                  disabled={isLoading || !!stockCardData.isConfirmed}
                >
                  Delete
                </Button>
              )}
            </>
          ) : (
            <>
              {!stockCardData.isConfirmed && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onConfirm}
                  disabled={isLoading || !!validationMessage}
                  startIcon={
                    isLoading ? <CircularProgress size={18} color="inherit" /> : null
                  }
                >
                  Save
                </Button>
              )}
            </>
          )}
        </Box>
      </ListItem>
      {isEditing && !!stockCardData.isConfirmed && (
        <ListItem>
          <Typography color="secondary" variant="body2">
            Kartu stok tidak dapat dihapus karena sudah dikonfirmasi.
          </Typography>
        </ListItem>
      )}
      {validationMessage &&
        !stockCardData.isConfirmed && (
          <ListItem>
            <Alert severity="warning">{validationMessage}</Alert>
          </ListItem>
        )}
    </List>
  );
}
